import {
  Component,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MatOption } from '@angular/material/core';

import { Router } from '@angular/router';

import * as _moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';

import { KpimasterService } from 'src/app/services/kpimaster.service';
import { ProductivityService } from 'src/app/services/productivity-service';
import { UserManagementService } from 'src/app/services/usermanagement.service';

import 'ag-grid-enterprise';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine-dark.css';
import { Chart } from 'angular-highcharts';
import { TranslaterService } from 'src/app/services/translater.service';
import {  TranslateService } from '@ngx-translate/core';
import { CrewScheduleService } from 'src/app/services/crewSchedule.service';
import { Multilingual } from 'src/app/services/multilingual';
import { MatCheckboxChange } from '@angular/material/checkbox';
import * as Highcharts from 'highcharts';
import * as moment from 'moment';
import Exporting from 'highcharts/modules/exporting';
import More from 'highcharts/highcharts-more';
import ExportData from 'highcharts/modules/export-data';
import Accessibility from 'highcharts/modules/accessibility';
import { MatSelect } from '@angular/material/select';
More(Highcharts);
Exporting(Highcharts);
ExportData(Highcharts);
Accessibility(Highcharts);

@Component({
  selector: 'app-parameter-analysis-dashboard',
  templateUrl: './parameter-analysis-dashboard.component.html',
  styleUrls: ['./parameter-analysis-dashboard.component.scss']
})
export class ParameterAnalysisDashboardComponent implements OnInit {
  @ViewChild('allSelected') private allSelected: MatSelect;
  @ViewChild('allSelectedAlarm') allSelectedAlarm: MatSelect;
  @ViewChild('singleSelected') private singleSelected: MatOption;

  selectedMachines: any = [];
  selectedMachinesAlarm: any = [];
  unselectAll: boolean = false;
  allSelectedAlarmOption=false;
  allSelectedParameterOption=false;
  highChartsColor = [
    '#00008B',
    '#34A56F',
    '#F80000',
    '#2D0A77',
    '#8C001A',
    '#FF69B4',
    '#FA4A08',
    '#5453A6',
    '#8B008B',
    '#3090C7',
    '#F1C40F',
    '#CB4335',
    '#36454F',
    '#A569BD',
    '#FFA500',
    '#179fcc',
    '#093323',
    '#08fa03',
    '#048b8e',
    '#9637A4',
    '#F39C12',
    '#0b774e',
    '#F5B7B1',
    '#0d98da',
    '#512E5F',
    '#C471A5',
    '#0034bb',
    '#06573d',
    '#0d6e54',
    '#0692aa',
    '#611745',
    '#F80000',
    '#FFDF00',
    '#6D81A8',
    '#08FAC7',
    '#D208FA',
    '#FAEB08',
  ];
  rangeAlarm = new FormGroup({
    dateStart: new FormControl(),
    dateEnd: new FormControl(),
  });

  rangeParameter = new FormGroup({
    dateStart: new FormControl(),
    dateEnd: new FormControl(),
  });

  rangeCycle = new FormGroup({
    dateStart: new FormControl(),
    dateEnd: new FormControl(),
  });
  alarmUnit =  new FormGroup({
    unit: new FormControl()
  });
  format = 'YYYY-MM-DD HH:mm:ss';
  checked: boolean;
  searchText: string;
  searchTextAlaram:string;
  AnalysisDashboardForm!: FormGroup;
  CycleAnalysisForm!: FormGroup;
  AlarmDashboardForm!: FormGroup;
  form!: FormGroup;
  filteredGroups: any;
  filteredPlants: any;
  filteredLines: any;
  filteredUnits: any;

  filteredCycleGroups: any;
  filteredCyclePlants: any;
  filteredCycleLines: any;
  filteredCycleUnits: any;

  filteredAlarmGroups: any;
  filteredAlarmPlants: any;
  filteredAlarmLines: any;
  filteredAlarmUnits: any;

  filteredParameterGroup: any;
  filteredParameters: any;
  breadcrumList: any;
  isSelectedLine = false;
  selectedFreq!: any;
  IsAccess: any;
  IsWrite: any;
  GroupList!: any[];
  PlantList1!: any[];
  lineList!: any[];
  unitList!: any[];
  parametersDD!: any[];
  variableGroupList!: any[];
  variableGroupParametersList!: any[];
  parameterData!: any[];
  parameterHoursData!: any[];
  alarmHoursData!: any[];
  cycleData !: any[];
  languageDir = 'ltr';
  langObj: any = {};
  moduleId!: any;
  pageId!: any;
  lang: any;
  key: any;
  selected: any = [];
  selectedParameter: any = [];
  activeButton!: any;
  activeButtonCycle!: any;
  onedayParametersChart!: Chart;
  onehourParametersChart!: Chart;
  monthParametersChart!: any;
  weekParametersChart!: any;
  alarmAnalysis!: any;
  datapoints1: any[];
  parametersList: any[];
  cycleAnalysis!: any;
  options: any;
  constructor(private formBuilder: FormBuilder,
    private kpiMaster: KpimasterService,
    private toaster: ToastrService,
    private usermanagementService: UserManagementService,
    private productivityservice: ProductivityService,
    private spinner: NgxSpinnerService,
    public router: Router,
    private translater: TranslaterService,
    private translate: TranslateService,
    private crewService: CrewScheduleService,) { }

  ngOnInit(): void {
    localStorage.setItem('O3RightMenuId', '293'); // for navigate from meeting matrix
    this.initForm();
    this.GetBreadcrumList();
    this.GetMenuAccess();
    this.datasource();
    this.getGroup();
    this.getAlarmGroup();
  }
  initForm() {
    const dateStart = new Date();
    dateStart.setDate(dateStart.getDate() - 183);
    dateStart.setHours(0);
    dateStart.setMinutes(0);
    dateStart.setSeconds(0);

    const dateEnd = new Date();
    dateEnd.setDate(dateEnd.getDate());

    this.rangeParameter.get('dateStart').setValue(dateStart);
    this.rangeParameter.get('dateEnd').setValue(dateEnd);

    this.AnalysisDashboardForm = this.formBuilder.group({
      UserGroup1: ['', Validators.required],
      UserPlant1: ['', Validators.required],
      unit: ['', Validators.required],
      line: ['', Validators.required],
      dateStart: [dateStart, Validators.required],
      dateEnd: [dateEnd, Validators.required],
      shift: ['', []],
      searchval: [''],
      parameterGroup: []
    });

    const stDTCycle = new Date();
    stDTCycle.setDate(stDTCycle.getDate()-30);
    stDTCycle.setHours(3);
    stDTCycle.setMinutes(0);
    stDTCycle.setSeconds(0);
   
    this.rangeCycle.get('dateStart').setValue(stDTCycle);
    this.rangeCycle.get('dateEnd').setValue(dateEnd);

    this.CycleAnalysisForm = this.formBuilder.group({
      UserGroup1: ['', Validators.required],
      UserPlant1: ['', Validators.required],
      unit: ['', Validators.required],
      line: ['', Validators.required],
      dateStart: [stDTCycle, Validators.required],
      dateEnd: [dateEnd, Validators.required],
      shift: ['', []],
      searchval: [''],
      parameters: [],
      frequency: ['']
    });
    this.CycleAnalysisForm.get('frequency').setValue('Daily');

    this.rangeAlarm.get('dateStart').setValue(stDTCycle);
    this.rangeAlarm.get('dateEnd').setValue(dateEnd);

    this.AlarmDashboardForm = this.formBuilder.group({
      UserGroup1: ['', Validators.required],
      UserPlant1: ['', Validators.required],
      unit: ['', Validators.required],
      line: ['', Validators.required],
      dateStart: [stDTCycle, Validators.required],
      dateEnd: [dateEnd, Validators.required],
      shift: ['', []],
      searchval: [''],
      parameters: [],
      frequency: ['']
    });

  }

  onChangeGroup(data: any): void {
    this.getPlants(data);
    this.resetData();
  }
  onChangeLine(data: any): void {
    this.getUnit(data.value);
    this.resetData();
  }
  onChangePlant(data: any): void {
    this.getLine(data.value);
    this.resetData();
  }


  onParameterRangeChange() {
    const { dateStart, dateEnd } = this.rangeParameter.value;
    this.AnalysisDashboardForm.get('dateStart').patchValue(moment(
      new Date(new Date(dateStart).setHours(0, 0, 0, 0))
    ).format('YYYY-MM-DD HH:mm:ss'));
    this.AnalysisDashboardForm.get('dateEnd').patchValue(moment(
      new Date(new Date(dateEnd).setHours(0, 0, 0, 0))
    ).format('YYYY-MM-DD HH:mm:ss'));
  }

  resetData() {
    this.AnalysisDashboardForm.get('unit').patchValue('');
    this.selectedMachines = [];
    this.getVariableParameters();
    this.selected = [];
    this.drawParameterTrends();
    this.drawParameterHoursTrends();
  }

  GetMenuAccess(): void {
    const key = {
      Id: localStorage.getItem('O3RightMenuId'),
    };
    this.kpiMaster.GetMenuAccess(key).subscribe(
      (data: any) => {
        // this.permisson = data;
        this.IsAccess = data.IsAccess;
        this.IsWrite = data.IsWrite;
      },
      (error) => {
        this.toaster.error('Error', error.error.message);
      }
    );
  }
  public getLangWords() {
    const key = {
      ModuleId: this.moduleId,
      PageId: this.pageId,
      LanguageId: this.translate.currentLang === 'en' ? 1 : this.translate.currentLang === 'ar' ? 2 : this.translate.currentLang === 'fr' ? 3 : this.translate.currentLang === 'sp' ? 4 : this.translate.currentLang === 'gr' ? 5 : this.translate.currentLang === 'du' ? 6 : 1,
    };
    this.translater.getLangWords(key).subscribe((res: any) => {
      let obj: any = {};
      res.tagList.map((elem: any) => {
        obj[elem.tagName] = elem.translatedValue;
      });
      this.langObj = obj;
      if (this.langObj) {
        //  this.gridApi.refreshHeader();
      }
    });
  }

  //menu and breadcrumb
  GetBreadcrumList(): any {
    const obj = {
      MenuId:
        localStorage.getItem('O3RightMenuId') === null
          ? 1
          : localStorage.getItem('O3RightMenuId'),
    };
    // tslint:disable-next-line: align
    this.usermanagementService.GetBreadcrumList(obj).subscribe(
      (data: any) => {
        this.breadcrumList = data.BreadcrumList;
        this.moduleId = this.breadcrumList[0].id;
        this.pageId = this.breadcrumList[this.breadcrumList.length - 1].id;
        console.log(data.BreadcrumList);
        this.getLangWords();
        this.lang = new Multilingual(this.translater, this.translate);
        this.lang.getLangWords();
      },
      (error) => {
        this.toaster.error('Error', error.ErrorMessage);
      }
    );
  }

  DisplayRightmenu(menuId: any, url: any): any {
    localStorage.setItem('O3RightMenuId', menuId);
    this.router
      .navigateByUrl('/', { skipLocationChange: true })
      .then(() => this.router.navigate([url]));
  }

  datasource(): void {
    const key = {
      UserId: 206, //later it will be change this is only for testing
    };
    const id = {
      value: 0,
    };
    this.productivityservice.getGroupData(key).subscribe(
      (data: any) => {
        this.GroupList = data.lstEG;
        if (this.GroupList.length > 0) {
          id.value = data.lstEG[0].EG_Id;

          this.AnalysisDashboardForm.patchValue({
            UserGroup1: data.lstEG[0].EG_Id,
            UserPlant1: data.lstEG[0].EG_Id,
          });
          this.filteredGroups = this.GroupList.slice();
          this.getPlants(id);
        }
      },
      (error: any) => {
        this.toaster.error('error', error.message);
      }
    );
  }

  getPlants(event: any): void {
    const key = {
      EG_ID: this.AnalysisDashboardForm.value.UserGroup1,
      userId: 206,
    };
    this.productivityservice.getPlantsData(key).subscribe(
      (data: any) => {
        this.PlantList1 = data.lstPlant;
        if (this.PlantList1.length > 0) {
          const id = data.lstPlant[0].PT_Id;
          this.AnalysisDashboardForm.get('UserPlant1')?.patchValue(id);
          this.getLine(id);
        }
        this.filteredPlants = this.PlantList1.slice();

      },
      (error: any) => {
        this.toaster.error('Error', error.message);
      }
    );
  }
  getLine(id: any) {
    const key = {
      PT_ID: this.AnalysisDashboardForm.value.UserPlant1,
      userId: 206,
    };

    this.productivityservice.getLineData(key).subscribe(
      (data: any) => {

        this.lineList = data.lstLine;
        this.filteredLines = this.lineList.slice();
        if (this.lineList.length > 0) {
          const lineDefault = this.lineList[0];
          this.AnalysisDashboardForm.controls.line.patchValue(lineDefault.PL_Id);

          this.getUnit(lineDefault.PL_Id);
        }
      },
      (error: any) => {
        this.toaster.error('Error', error.message);
      }
    );
  }

  getUnit(id: number) {
    const key = {
      PL_ID: this.AnalysisDashboardForm.value.line,
      userId: 206,
    };

    this.productivityservice.getUnitDataByMultipleLines(key).subscribe(
      (data: any) => {
        this.unitList = data.lstUnit;
        if (this.unitList.length > 0) {
          this.filteredUnits = [];
          this.filteredUnits = this.unitList.slice();
          // const unitDefault = this.unitList[0];
          //   this.AnalysisDashboardForm.get('unit').setValue(unitDefault.PU_Id);

        }
        // this.onSubmit();
        // this.constructData_CS();
        // this.getVariableGroup();
      },
      (error: any) => {
        this.toaster.error('Error', error.message);
      }
    );
  }
  onSubmit(): void {
   
  }

  today(): void {
    this.constructData_CS();
    this.getAnalysisDashboard();
  }

  yesterday(): void {
    this.constructData_LS();
    this.getAnalysisDashboard();
  }

  yesterdayFullDay(): void {
    this.constructData_1D();
    this.getAnalysisDashboard();
  }

  lastWeek(): void {
    this.constructData_1W();
    this.getAnalysisDashboard();
  }

  lastMonth(): void {
    this.constructData_1M();
    this.getAnalysisDashboard();
  }

  onChangeParameterGroup() {
    this.selected = [];
    this.drawParameterTrends();
    this.drawParameterHoursTrends();
  }

  constructData_CS(): void {
    const stDT = new Date();
    stDT.setDate(stDT.getDate());
    stDT.setHours(0);
    stDT.setMinutes(0);
    stDT.setSeconds(0);
    const edDT = new Date();
    edDT.setDate(edDT.getDate());
    this.rangeParameter.get('dateStart')?.patchValue(stDT);
    this.rangeParameter.get('dateEnd')?.patchValue(edDT);

  }

  constructData_LS(): void {
    const stDT = new Date();
    stDT.setDate(stDT.getDate() - 1);
    stDT.setHours(0);
    stDT.setMinutes(0);
    stDT.setSeconds(0);

    const edDT = new Date();
    edDT.setDate(edDT.getDate());
    edDT.setHours(6);
    edDT.setMinutes(0);
    edDT.setSeconds(0);
    this.rangeParameter.get('dateStart')?.patchValue(stDT);
    this.rangeParameter.get('dateEnd')?.patchValue(edDT);

  }

  constructData_1D(): void {
    const stDT = new Date();
    stDT.setDate(stDT.getDate() - 1);
    stDT.setHours(0);
    stDT.setMinutes(0);
    stDT.setSeconds(0);

    const edDT = new Date();
    edDT.setDate(edDT.getDate());
    edDT.setHours(6);
    edDT.setMinutes(0);
    edDT.setSeconds(0);
    this.rangeParameter.get('dateStart')?.patchValue(stDT);
    this.rangeParameter.get('dateEnd')?.patchValue(edDT);


  }

  constructData_1W(): void {
    const stDT = new Date();
    stDT.setDate(stDT.getDate() - 6);
    stDT.setHours(0);
    stDT.setMinutes(0);
    stDT.setSeconds(0);

    const edDT = new Date();
    edDT.setDate(edDT.getDate());
    edDT.setHours(0);
    edDT.setMinutes(0);
    edDT.setSeconds(0);
    this.rangeParameter.get('dateStart')?.patchValue(stDT);
    this.rangeParameter.get('dateEnd')?.patchValue(edDT);

  }

  constructData_1M(): void {
    const stDT = new Date();
    stDT.setDate(stDT.getDate() - 29);
    stDT.setHours(0);
    stDT.setMinutes(0);
    stDT.setSeconds(0);

    const edDT = new Date();
    edDT.setDate(edDT.getDate());
    edDT.setHours(0);
    edDT.setMinutes(0);
    edDT.setSeconds(0);
    this.rangeParameter.get('dateStart')?.patchValue(stDT);
    this.rangeParameter.get('dateEnd')?.patchValue(edDT);
  }
 
  getVariableGroup(): void {
    const key = {
      Pu_id: this.AnalysisDashboardForm.value.unit,
      VG_Id: 0
    }
    this.productivityservice.getVariableGroup(key).subscribe(
      (data: any) => {
        this.variableGroupList = data.VariableGroupList;
        if (this.variableGroupList.length > 0) {
          const parameterDefault = this.variableGroupList[0];
          this.AnalysisDashboardForm.controls.parameterGroup.patchValue(parameterDefault.VG_Id);
          this.filteredParameterGroup = this.variableGroupList.slice();

        }
        this.getVariableParameters();
      },
      (error: any) => {
        this.toaster.error('Error', error.message);
      }
    );
  }

  getVariableParameters(): void {
    const key = {
      PUID: this.selectedMachines.toString(),
    }
    this.productivityservice.getVariableGroupParametrs(key).subscribe(
      (data: any) => {
        this.variableGroupParametersList = data.Table;
        const listcheck: any[] = [];
        const uniquemachine = [
          ...new Set(
            data.Table.map((item) => {
              return item.PU_Desc;
            })
          ),
        ];
        for (const item of uniquemachine) {
          const obj = {
            machine: item,
            data: data.Table
              .filter((x) => x.PU_Desc === item)
              .map((elem) => {
                return {
                  Var_Desc: elem.Var_Desc,
                  checked: this.selected.find(val=> val.Var_Id === elem.Var_Id ? true :false),
                  Var_Id: elem.Var_Id,
                };
              }),
          };
          listcheck.push(obj);
        }
        const firstItem = '';
        listcheck.sort((x, y) =>
          x.machine === firstItem ? -1 : y.machine === firstItem ? 1 : 0
        );
        this.datapoints1 = listcheck;
      },
      (error: any) => {
        this.toaster.error('Error', error.message);
      }
    );
  }
  getAnalysisDashboard() {
    var result = this.selected.map(function (val) {
      return val.Var_Id;
    }).join(',');
    this.spinner.show();
    const key = {
      startDate: this.rangeParameter.value.dateStart,
      endDate: this.rangeParameter.value.dateEnd,
      varId: result
    }
    this.productivityservice.getParameterAnalysisDashboard(key).subscribe(
      (data: any) => {
        this.parameterData = data.Table;
        this.parameterHoursData = data.Table1
        this.drawParameterTrends();
        this.drawParameterHoursTrends();
        this.spinner.hide();
      },
      (error: any) => {
        this.toaster.error('Error', error.message);
        this.spinner.hide();
      }
    );
  }


  userSelectClick(id, event: MatCheckboxChange) {
    if (event.checked) {
      this.variableGroupParametersList.forEach(val => {
        if (val.Var_Id === id) {
          this.selected.push({ Var_Id: val.Var_Id, Var_Desc: val.Var_Desc });
        }
      });
      if (this.selected.length > 0) {
        this.getAnalysisDashboard();
      }
    } else {
      this.selected.pop(id);
      this.getAnalysisDashboard();
    }
  }

  showPhase(event: any) {
    this.activeButton = event;
  }

  showPhaseCycle(event: any) {
    this.activeButtonCycle = event;
  }
  drawParameterTrends() {
    const yAxisArr: any[] = [];
    const array: any[] = [];
    const names = [];
    this.selected.forEach((val, index) => {
      names.push(val);
    });
    var data: any[] = [];
    data = this.parameterData;
    for (let i = 0; i < names.length; i++) {
      const dataArr = [];
      for (let j = 0; j < data.length; j++) {
        if (names[i].Var_Id === data[j].Var_Id) {
          dataArr.push({ x: this.getMili(data[j].ResultOn), y: parseFloat(data[j].Result), label: data[j].Var_Desc });
        }

      }
      let negativeArr = [];
      console.log(dataArr);
      negativeArr = dataArr.map((c) => c.y);
      const obj = {
        tooltip: {
          valueDecimals: 2,
        },
        name: names[i].Var_Desc,
        type: 'line',
        data: dataArr,
        color: this.highChartsColor[i],
        yAxis: i,
      };
      if (obj.data.length > 0) {
        array.push(obj);
      }
      yAxisArr.push({
        lineWidth: 1,
        visible: true,
        // opposite:false,
        opposite: negativeArr.some((v) => v < 0) ? true : false,
        title: {
          text: names[i],
          style: {
            color: this.highChartsColor[i],
          },
        },
        labels: {
          style: {
            color: this.highChartsColor[i],
          },
        },
      });
    }
    yAxisArr.forEach((yAxis) => { // hide y axis
      yAxis.visible = false;
    });
    // creating chart
    Highcharts.stockChart('onedayParametersChart', {

      rangeSelector: {
        selected: 4
      },
      yAxis: yAxisArr,
      plotOptions: {
        series: {
          compare: 'percent',
          showInNavigator: true,
          turboThreshold: 1000000,
        },
      },
      credits: {
        enabled: false
      },
      legend: {
        enabled: true
      },
      tooltip: {
        pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b> ({point.change}%)<br/>',
        valueDecimals: 2,
        split: true
      },

      series: array
    });
  }

  drawParameterHoursTrends() {
    const yAxisArr: any[] = [];
    const array: any[] = [];
    const names = [];
    this.selected.forEach((val, index) => {
      names.push(val);
    });
    var data: any[] = [];
    data = this.parameterHoursData;
    for (let i = 0; i < names.length; i++) {
      const dataArr = [];
      for (let j = 0; j < data.length; j++) {
        if (names[i].Var_Id === data[j].Var_Id) {
          dataArr.push({ x: this.getMili(data[j].ResultOn), y: parseFloat(data[j].Result), label: data[j].Var_Desc });
        }

      }
      let negativeArr = [];
      console.log(dataArr);
      negativeArr = dataArr.map((c) => c.y);
      const obj = {
        tooltip: {
          valueDecimals: 2,
        },
        name: names[i].Var_Desc,
        type: 'line',
        data: dataArr,
        color: this.highChartsColor[i],
        yAxis: i,
      };
      if (obj.data.length > 0) {
        array.push(obj);
      }
      yAxisArr.push({
        lineWidth: 1,
        visible: true,
        // opposite:false,
        opposite: negativeArr.some((v) => v < 0) ? true : false,
        title: {
          text: names[i],
          style: {
            color: this.highChartsColor[i],
          },
        },
        labels: {
          style: {
            color: this.highChartsColor[i],
          },
        },
      });
    }
    yAxisArr.forEach((yAxis) => { // hide y axis
      yAxis.visible = false;
    });
    // creating chart
    Highcharts.stockChart('onehourParametersChart', {

      rangeSelector: {
        selected: 4
      },
      yAxis: yAxisArr,
      plotOptions: {
        series: {
          compare: 'percent',
          showInNavigator: true,
          turboThreshold: 1000000,
        },
      },
      credits: {
        enabled: false
      },
      legend: {
        enabled: true
      },
      tooltip: {
        pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b> ({point.change}%)<br/>',
        valueDecimals: 2,
        split: true
      },

      series: array
    });
  }

  getMili(Start_Time: any) {
    var date = moment(Start_Time).format(this.format);
    return new Date(date).getTime();
  }

  toggleAllSelection() {
    if (this.allSelectedParameterOption) {
      this.allSelected.options.forEach((item: MatOption) => item.select());
      this.selectedMachines = this.AnalysisDashboardForm.controls.unit.value;
      this.getVariableParameters();
    } else {
      this.allSelected.options.forEach((item: MatOption) => item.deselect());
      this.selectedMachines = this.AnalysisDashboardForm.controls.unit.value;
      this.getVariableParameters();
    }
  }
  onUnitChange() {
    let newStatus = true;
    this.allSelected.options.forEach((item: MatOption) => {
      if (!item.selected) {
        newStatus = false;
        this.selectedMachines = this.AnalysisDashboardForm.controls.unit.value;
        this.getVariableParameters();
       
      }else{
        this.selectedMachines = this.AnalysisDashboardForm.controls.unit.value;
        this.getVariableParameters();
      }
    });
    this.allSelectedParameterOption = newStatus;
  }


  selectAllLines() {
    if (this.AnalysisDashboardForm.get('line').value.length) {
      if (this.AnalysisDashboardForm.get('line').value.includes(0)) {
      }
      const filterdArray = this.filteredLines?.map(
        (item: any) => item?.PL_Id
      );
      this.AnalysisDashboardForm.get('line')?.setValue([...filterdArray, '0']);
    } else {
      this.AnalysisDashboardForm.get('line')?.setValue([]);
    }

  }
  // ========================================================= Cycle Analysis==================================================================

  onTabChanged(event): void {
    this.getGroup();
  }

  onCycleChangeGroup(data: any): void {
    this.getPlantDD(data);
  }
  onCycleChangeLine(data: any): void {
    this.getUnitDD(data.value);
  }
  onCycleChangePlant(data: any): void {
    this.getLineDD(data.value);
  }

  onUnitChangeCycle(): void {
    this.getVariableParametersDD();
  }

  onCycleRangeChange() {
    const { dateStart, dateEnd } = this.rangeCycle.value;
    this.CycleAnalysisForm.get('dateStart').patchValue(moment(
      new Date(new Date(dateStart).setHours(0, 0, 0, 0))
    ).format('YYYY-MM-DD HH:mm:ss'));
    this.CycleAnalysisForm.get('dateEnd').patchValue(moment(
      new Date(new Date(dateEnd).setHours(0, 0, 0, 0))
    ).format('YYYY-MM-DD HH:mm:ss'));
  };

  getGroup(): void {
    const key = {
      UserId: 206, //later it will be change this is only for testing
    };
    const id = {
      value: 0,
    };
    this.productivityservice.getGroupData(key).subscribe(
      (data: any) => {
        this.GroupList = data.lstEG;
        if (this.GroupList.length > 0) {
          this.CycleAnalysisForm.get('UserGroup1')?.patchValue(this.GroupList[0].EG_Id);
          this.filteredCycleGroups = this.GroupList.slice();
          this.getPlantDD(id);
        }
      },
      (error: any) => {
        this.toaster.error('error', error.message);
      }
    );
  }

  getPlantDD(event: any): void {
    const key = {
      EG_ID: this.CycleAnalysisForm.value.UserGroup1,
      userId: 206,
    };
    this.productivityservice.getPlantsData(key).subscribe(
      (data: any) => {
        this.PlantList1 = data.lstPlant;
        if (this.PlantList1.length > 0) {
          const id = data.lstPlant[0].PT_Id;
          this.CycleAnalysisForm.get('UserPlant1')?.patchValue(id);
          this.getLineDD(id);
        }
        this.filteredCyclePlants = this.PlantList1.slice();

      },
      (error: any) => {
        this.toaster.error('Error', error.message);
      }
    );
  }
  getLineDD(id: any) {
    const key = {
      PT_ID: this.CycleAnalysisForm.value.UserPlant1,
      userId: 206,
    };

    this.productivityservice.getLineData(key).subscribe(
      (data: any) => {

        this.lineList = data.lstLine;
        this.filteredCycleLines = this.lineList.slice();
        if (this.lineList.length > 0) {
          const lineDefault = this.lineList[0];
          this.CycleAnalysisForm.get('line')?.patchValue(lineDefault.PL_Id);

          this.getUnitDD(lineDefault.PL_Id);
        }
      },
      (error: any) => {
        this.toaster.error('Error', error.message);
      }
    );
  }

  getUnitDD(id: number) {
    const key = {
      PL_ID: this.CycleAnalysisForm.value.line,
      userId: 206,
    };

    this.productivityservice.getUnitDataByMultipleLines(key).subscribe(
      (data: any) => {
        this.unitList = data.lstUnit;
        if (this.unitList.length > 0) {
          this.filteredCycleUnits = [];
          this.filteredCycleUnits = this.unitList.slice();
          const unitDefault = this.unitList[0];
          this.CycleAnalysisForm.get('unit')?.patchValue(unitDefault.PU_Id);
          this.getVariableParametersDD();
        }
      },
      (error: any) => {
        this.toaster.error('Error', error.message);
      }
    );
  }

  getAnalysisDashboardCycle() {
    this.spinner.show();
    const key = {
      startDate: this.rangeCycle.value.dateStart,
      endDate: this.rangeCycle.value.dateEnd,
      varId: this.CycleAnalysisForm.value.parameters
    }
    this.productivityservice.getParameterAnalysisDashboard(key).subscribe(
      (data: any) => {
        this.selectedFreq = this.CycleAnalysisForm.get('frequency').value;
        if (this.CycleAnalysisForm.get('frequency').value === 'Daily') {
         this.checked === true ? this.cycleData = data.Table1 :  this.cycleData = data.Table8
          this.drawParameterCycleParameter();
        } else if (this.CycleAnalysisForm.get('frequency').value === 'Weekly') {
          this.checked === true  ? this.cycleData = data.Table2 : this.cycleData = data.Table5
          this.drawParameterCycleweekly();
        } else if (this.CycleAnalysisForm.get('frequency').value === 'Monthly') {
          this.checked === true  ? this.cycleData = data.Table6 : this.cycleData = data.Table7
          this.drawParameterCyclemonthly();
        }

        this.spinner.hide();
      },
      (error: any) => {
        this.toaster.error('Error', error.message);
        this.spinner.hide();
      }
    );
  }

  getVariableParametersDD(): void {
    const key = {
      PUID: this.CycleAnalysisForm.value.unit
    }
    this.productivityservice.getVariableGroupParametrs(key).subscribe(
      (data: any) => {
        this.parametersDD = data.Table;
        this.filteredParameters = this.parametersDD.slice();

      },
      (error: any) => {
        this.toaster.error('Error', error.message);
      }
    );
  }

  onChangeParameterCycle() {
    this.getAnalysisDashboardCycle();
  }

  today_Cycle(): void {
    this.constructData_CS_Cycle();
    this.getAnalysisDashboardCycle();
  }

  yesterday_Cycle(): void {
    this.constructData_LS_Cycle();
    this.getAnalysisDashboardCycle();
  }

  yesterdayFullDay_Cycle(): void {
    this.constructData_1D_Cycle();
    this.getAnalysisDashboardCycle();
  }

  lastWeek_Cycle(): void {
    this.constructData_1W_Cycle();
    this.getAnalysisDashboardCycle();
  }

  lastMonth_Cycle(): void {
    this.constructData_1M_Cycle();
    this.getAnalysisDashboardCycle();
  }

  constructData_CS_Cycle(): void {
    const stDT = new Date();
    stDT.setDate(stDT.getDate());
    stDT.setHours(0);
    stDT.setMinutes(0);
    stDT.setSeconds(0);
    const edDT = new Date();
    edDT.setDate(edDT.getDate());
    this.rangeCycle.get('dateStart')?.patchValue(stDT);
    this.rangeCycle.get('dateEnd')?.patchValue(edDT);

  }

  constructData_LS_Cycle(): void {
    const stDT = new Date();
    stDT.setDate(stDT.getDate() - 1);
    stDT.setHours(0);
    stDT.setMinutes(0);
    stDT.setSeconds(0);

    const edDT = new Date();
    edDT.setDate(edDT.getDate());
    edDT.setHours(0);
    edDT.setMinutes(0);
    edDT.setSeconds(0);
    this.rangeCycle.get('dateStart')?.patchValue(stDT);
    this.rangeCycle.get('dateEnd')?.patchValue(edDT);

  }

  constructData_1D_Cycle(): void {
    const stDT = new Date();
    stDT.setDate(stDT.getDate() - 1);
    stDT.setHours(0);
    stDT.setMinutes(0);
    stDT.setSeconds(0);

    const edDT = new Date();
    edDT.setDate(edDT.getDate());
    edDT.setHours(0);
    edDT.setMinutes(0);
    edDT.setSeconds(0);
    this.rangeCycle.get('dateStart')?.patchValue(stDT);
    this.rangeCycle.get('dateEnd')?.patchValue(edDT);


  }

  constructData_1W_Cycle(): void {
    const stDT = new Date();
    stDT.setDate(stDT.getDate() - 6);
    stDT.setHours(0);
    stDT.setMinutes(0);
    stDT.setSeconds(0);

    const edDT = new Date();
    edDT.setDate(edDT.getDate());
    edDT.setHours(0);
    edDT.setMinutes(0);
    edDT.setSeconds(0);
    this.rangeCycle.get('dateStart')?.patchValue(stDT);
    this.rangeCycle.get('dateEnd')?.patchValue(edDT);

  }

  constructData_1M_Cycle(): void {
    const stDT = new Date();
    stDT.setDate(stDT.getDate() - 29);
    stDT.setHours(0);
    stDT.setMinutes(0);
    stDT.setSeconds(0);

    const edDT = new Date();
    edDT.setDate(edDT.getDate());
    edDT.setHours(0);
    edDT.setMinutes(0);
    edDT.setSeconds(0);
    this.rangeCycle.get('dateStart')?.patchValue(stDT);
    this.rangeCycle.get('dateEnd')?.patchValue(edDT);
  }

  drawParameterCycleParameter() {
    const yAxisArr: any[] = [];
    const xAxixArr: any[] = [];
    let array: any[] = [];
    const names = [];
    let diceEntries = new Set<string>();
    // this.parametersDD.forEach((val, index) => {
    //   names.push(this.parametersDD.find(val => val.Var_Id === this.CycleAnalysisForm.get('parameters').value));

    // });
    names.push(this.parametersDD.find(val => val.Var_Id === this.CycleAnalysisForm.get('parameters').value));
    this.cycleData.forEach(obj => {
      // var today = new Date();
      // var dd = today.getDate();
      //   var mm = today.getMonth() + 1;
      //   var yyyy = today.getFullYear();
      //   var resultDate = dd + '/' + mm + '/' + yyyy;
      diceEntries.add(moment(obj.ResultOn).format('L'));
    })

    var data: any[] = [];
    data = this.cycleData;

    for (let i = 0; i < diceEntries.size; i++) {
      const dataArr = [];
      for (let j = 0; j < data.length; j++) {
        if ([...diceEntries][i] === moment(data[j].ResultOn).format('L')) {
          console.log(this.getMili(data[j].ResultOn));
          dataArr.push(parseFloat(data[j].Result));
        }
      }
      const obj = {
        name: 'Day-' + (i + 1),
        type: undefined,
        data: dataArr,
      };
      if (obj.data.length > 0) {
        array.push(obj);
      }
    }
    this.options = {
      chart: {
        type: 'spline',
        scrollablePlotArea: {
          minWidth: 1,
          scrollPositionX: 1
        }
      },
      title: {
        text: ''
      },
      subtitle: {
        text: ''
      },
      xAxis: {
        //tickInterval: 1000 * 60 * 60 * 24 * 365,
        type: 'datetime',
        // min: this.getMili(this.CycleAnalysisForm.get('dateStart').value),
        // max: Date.UTC(2023, 2, 2, 23, 59, 59),
        dateTimeLabelFormats: {
          day: "%H:%M"
        },
        //tickInterval: 1,
        labels: {
          overflow: 'justify',
          style: {
            color: '#46474a'
          }
        },
      },
      yAxis: {
        tickWidth: 1,
        title: {
          text: ''
        },
        lineWidth: 1,
        opposite: true
      },
      tooltip: {
        valueSuffix: '',
        split: true
      },
      credits: {
        enabled: false
      },
      plotOptions: {
        spline: {
          lineWidth: 2,
          states: {
            hover: {
              lineWidth: 5
            }
          },
          marker: {
            enabled: false
          },
          pointInterval: 3600000, // one hour
          pointStart: this.getMili(this.CycleAnalysisForm.get('dateStart').value)
        }
      },
      series: array,
    };
    let chart = new Chart(this.options);
    this.cycleAnalysis = chart;
  }

  drawParameterCycleweekly() {
    const yAxisArr: any[] = [];
    const xAxixArr: any[] = [];
    let array: any[] = [];
    const names = [];
    let diceEntries = new Set<string>();
    names.push(this.parametersDD.find(val => val.Var_Id === this.CycleAnalysisForm.get('parameters').value));
    this.cycleData.forEach(obj => {
      diceEntries.add(obj.WeekNo);
    })

    var data: any[] = [];
    data = this.cycleData;

    for (let i = 0; i < diceEntries.size; i++) {
      const dataArr = [];
      for (let j = 0; j < data.length; j++) {
        if ([...diceEntries][i] === data[j].WeekNo) {
          console.log(this.getMili(data[j].ResultOn));
          dataArr.push(parseFloat(data[j].Result));
        }
      }
      const obj = {
        name: 'week-' + [...diceEntries][i],
        type: undefined,
        data: dataArr,
      };
      if (obj.data.length > 0) {
        array.push(obj);
      }
    }

    this.options = {
      chart: {
        type: 'line',
        event:{

        },
        scrollablePlotArea: {
          minWidth: 1,
          scrollPositionX: 1
        },
      },
      title: {
        text: ''
      },
      subtitle: {
        text: ''
      },
      xAxis: {
        // min:1,
        // max:7,
        categories: ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'],
      
        labels: {
            format: '<a href="{link}">{text}</a>'
        }
    },
      yAxis: {
        tickWidth: 1,
        title: {
          text: ''
        },
        lineWidth: 1,
        opposite: true
      },
      tooltip: {
        valueSuffix: '',
        split: true
      },
      credits: {
        enabled: false
      },
      series: array,
    };
    let chart = new Chart(this.options);
    this.weekParametersChart = chart;
  }
  drawParameterCyclemonthly() {
    const yAxisArr: any[] = [];
    const xAxixArr: any[] = [];
    let array: any[] = [];
    const names = [];
    let diceEntries = new Set<string>();
    names.push(this.parametersDD.find(val => val.Var_Id === this.CycleAnalysisForm.get('parameters').value));
    this.cycleData.forEach(obj => {
      diceEntries.add(obj.month);
    })

    var data: any[] = [];
    data = this.cycleData;

    for (let i = 0; i < diceEntries.size; i++) {
      const dataArr = [];
      for (let j = 0; j < data.length; j++) {
        if ([...diceEntries][i] === data[j].month) {
          console.log(this.getMili(data[j].ResultOn));
          dataArr.push(parseFloat(data[j].Result));
        }
      }
      const obj = {
        name: [...diceEntries][i],
        type: undefined,
        data: dataArr,
      };
      if (obj.data.length > 0) {
        array.push(obj);
      }
    }

    this.options = {
      chart: {
        type: 'line',
        event:{

        },
        scrollablePlotArea: {
          minWidth: 1,
          scrollPositionX: 1
        },
      },
      title: {
        text: ''
      },
      subtitle: {
        text: ''
      },
      xAxis: {
        // min:1,
        // max:7,
        categories: ['1','2','3','4','5','6','7','8','9','10','11','12','13','14','15','16','17','18','19','20','21','22','23','24','25','26','27','28','29','30','31'],
      
        labels: {
            format: '<a href="{link}">{text}</a>'
        }
    },
      yAxis: {
        tickWidth: 1,
        title: {
          text: ''
        },
        lineWidth: 1,
        opposite: true
      },
      tooltip: {
        valueSuffix: '',
        split: true
      },
      credits: {
        enabled: false
      },
      series: array,
    };
    let chart = new Chart(this.options);
    this.monthParametersChart = chart;
    }


 

  // ================================================================== Alarm Cycle====================================================================//

  onChangeAlarmGroup(data: any): void {
    this.getPlantDDAlarm(data);
    this.resetAlarmData();
  }
  onChangeAlarmLine(data: any): void {
    this.getUnitDDAlarm(data.value);
    this.resetAlarmData();
  }
  onChangeAlarmPlant(data: any): void {
    this.getLineDDAlarm(data.value);
    this.resetAlarmData();
  }


  onChangeParameterAlarm() {
    this.getAlarmAnalysisDashboard();
  }

  today_Alarm(): void {
    this.constructData_CS_Alarm();
    this.getAlarmAnalysisDashboard();
  }

  yesterday_Alarm(): void {
    this.constructData_LS_Alarm();
    this.getAlarmAnalysisDashboard();
  }

  yesterdayFullDay_Alarm(): void {
    this.constructData_1D_Alarm();
    this.getAlarmAnalysisDashboard();
  }

  lastWeek_Alarm(): void {
    this.constructData_1W_Alarm();
    this.getAlarmAnalysisDashboard();
  }

  lastMonth_Alarm(): void {
    this.constructData_1M_Alarm();
    this.getAlarmAnalysisDashboard();
  }

  constructData_CS_Alarm(): void {
    const stDT = new Date();
    stDT.setDate(stDT.getDate());
    stDT.setHours(0);
    stDT.setMinutes(0);
    stDT.setSeconds(0);
    const edDT = new Date();
    edDT.setDate(edDT.getDate());
    this.rangeAlarm.get('dateStart')?.patchValue(stDT);
    this.rangeAlarm.get('dateEnd')?.patchValue(edDT);

  }

  constructData_LS_Alarm(): void {
    const stDT = new Date();
    stDT.setDate(stDT.getDate() - 1);
    stDT.setHours(0);
    stDT.setMinutes(0);
    stDT.setSeconds(0);

    const edDT = new Date();
    edDT.setDate(edDT.getDate());
    edDT.setHours(0);
    edDT.setMinutes(0);
    edDT.setSeconds(0);
    this.rangeAlarm.get('dateStart')?.patchValue(stDT);
    this.rangeAlarm.get('dateEnd')?.patchValue(edDT);

  }

  constructData_1D_Alarm(): void {
    const stDT = new Date();
    stDT.setDate(stDT.getDate() - 1);
    stDT.setHours(0);
    stDT.setMinutes(0);
    stDT.setSeconds(0);

    const edDT = new Date();
    edDT.setDate(edDT.getDate());
    edDT.setHours(0);
    edDT.setMinutes(0);
    edDT.setSeconds(0);
    this.rangeAlarm.get('dateStart')?.patchValue(stDT);
    this.rangeAlarm.get('dateEnd')?.patchValue(edDT);


  }

  constructData_1W_Alarm(): void {
    const stDT = new Date();
    stDT.setDate(stDT.getDate() - 6);
    stDT.setHours(0);
    stDT.setMinutes(0);
    stDT.setSeconds(0);

    const edDT = new Date();
    edDT.setDate(edDT.getDate());
    edDT.setHours(0);
    edDT.setMinutes(0);
    edDT.setSeconds(0);
    this.rangeAlarm.get('dateStart')?.patchValue(stDT);
    this.rangeAlarm.get('dateEnd')?.patchValue(edDT);

  }

  constructData_1M_Alarm(): void {
    const stDT = new Date();
    stDT.setDate(stDT.getDate() - 29);
    stDT.setHours(0);
    stDT.setMinutes(0);
    stDT.setSeconds(0);

    const edDT = new Date();
    edDT.setDate(edDT.getDate());
    edDT.setHours(0);
    edDT.setMinutes(0);
    edDT.setSeconds(0);
    this.rangeAlarm.get('dateStart')?.patchValue(stDT);
    this.rangeAlarm.get('dateEnd')?.patchValue(edDT);
  }

  resetAlarmData() {
    this.AlarmDashboardForm.get('unit').patchValue('');
    this.selectedMachinesAlarm = [];
    this.getAlarmVariableParameters();
    this.selectedParameter = [];
    this.AlarmCycle();
  }

  onAlarmRangeChange() {
    const { dateStart, dateEnd } = this.rangeAlarm.value;
    this.AlarmDashboardForm.get('dateStart').patchValue(moment(
      new Date(new Date(dateStart).setHours(0, 0, 0, 0))
    ).format('YYYY-MM-DD HH:mm:ss'));
    this.AlarmDashboardForm.get('dateEnd').patchValue(moment(
      new Date(new Date(dateEnd).setHours(0, 0, 0, 0))
    ).format('YYYY-MM-DD HH:mm:ss'));
  }

  getAlarmGroup(): void {
    const key = {
      UserId: 206, //later it will be change this is only for testing
    };
    const id = {
      value: 0,
    };
    this.productivityservice.getGroupData(key).subscribe(
      (data: any) => {
        this.GroupList = data.lstEG;
        if (this.GroupList.length > 0) {
          this.AlarmDashboardForm.get('UserGroup1')?.patchValue(this.GroupList[0].EG_Id);
          this.filteredAlarmGroups = this.GroupList.slice();
          this.getPlantDDAlarm(id);
        }
      },
      (error: any) => {
        this.toaster.error('error', error.message);
      }
    );
  }

  getPlantDDAlarm(event: any): void {
    const key = {
      EG_ID: this.AlarmDashboardForm.value.UserGroup1,
      userId: 206,
    };
    this.productivityservice.getPlantsData(key).subscribe(
      (data: any) => {
        this.PlantList1 = data.lstPlant;
        if (this.PlantList1.length > 0) {
          const id = data.lstPlant[0].PT_Id;
          this.AlarmDashboardForm.get('UserPlant1')?.patchValue(id);
          this.getLineDDAlarm(id);
        }
        this.filteredAlarmPlants = this.PlantList1.slice();

      },
      (error: any) => {
        this.toaster.error('Error', error.message);
      }
    );
  }
  getLineDDAlarm(id: any) {
    const key = {
      PT_ID: this.AlarmDashboardForm.value.UserPlant1,
      userId: 206,
    };

    this.productivityservice.getLineData(key).subscribe(
      (data: any) => {

        this.lineList = data.lstLine;
        this.filteredAlarmLines = this.lineList.slice();
        if (this.lineList.length > 0) {
          const lineDefault = this.lineList[0];
          this.AlarmDashboardForm.get('line')?.patchValue(lineDefault.PL_Id);

          this.getUnitDDAlarm(lineDefault.PL_Id);
        }
      },
      (error: any) => {
        this.toaster.error('Error', error.message);
      }
    );
  }

  getUnitDDAlarm(id: number) {
    const key = {
      PL_ID: this.AlarmDashboardForm.value.line,
      userId: 206,
    };

    this.productivityservice.getUnitDataByMultipleLines(key).subscribe(
      (data: any) => {
        this.unitList = data.lstUnit;
        if (this.unitList.length > 0) {
          this.filteredAlarmUnits = [];
          this.filteredAlarmUnits = this.unitList.slice();
          const unitDefault = this.unitList[0];
          this.AlarmDashboardForm.get('unit')?.patchValue(unitDefault.PU_Id);
          this.getAlarmVariableParameters();
        }
      },
      (error: any) => {
        this.toaster.error('Error', error.message);
      }
    );
  }

  getAlarmVariableParameters(): void {
    const key = {
      PUID: this.selectedMachinesAlarm.toString(),
    }
    this.productivityservice.getVariableGroupParametrs(key).subscribe(
      (data: any) => {
        this.variableGroupParametersList = data.Table;
        const listcheck: any[] = [];
        const uniquemachine = [
          ...new Set(
            data.Table.map((item) => {
              return item.PU_Desc;
            })
          ),
        ];
        for (const item of uniquemachine) {
          const obj = {
            machine: item,
            data: data.Table
              .filter((x) => x.PU_Desc === item)
              .map((elem) => {
                return {
                  Var_Desc: elem.Var_Desc,
                  checked: this.selectedParameter.find(val=> val.Var_Id === elem.Var_Id ? true :false),
                  Var_Id: elem.Var_Id,
                };
              }),
          };
          listcheck.push(obj);
        }
        const firstItem = '';
        listcheck.sort((x, y) =>
          x.machine === firstItem ? -1 : y.machine === firstItem ? 1 : 0
        );
        this.parametersList = listcheck;
      },
      (error: any) => {
        this.toaster.error('Error', error.message);
      }
    );
  }

  
  toggleAllSelectionAlarm() {
    if (this.allSelectedAlarmOption) {
      this.allSelectedAlarm.options.forEach((item: MatOption) => item.select());
      this.selectedMachinesAlarm = this.AlarmDashboardForm.controls.unit.value;
      this.getAlarmVariableParameters();
    } else {
      this.allSelectedAlarm.options.forEach((item: MatOption) => item.deselect());
      this.selectedMachinesAlarm = this.AlarmDashboardForm.controls.unit.value;
      this.getAlarmVariableParameters();
    }
  }
   optionClick() {
    let newStatus = true;
    this.allSelectedAlarm.options.forEach((item: MatOption) => {
      if (!item.selected) {
        newStatus = false;
        this.selectedMachinesAlarm = this.AlarmDashboardForm.controls.unit.value;
        this.getAlarmVariableParameters();
       
      }else{
        this.selectedMachinesAlarm = this.AlarmDashboardForm.controls.unit.value;
        this.getAlarmVariableParameters();
      }
    });
    this.allSelectedAlarmOption = newStatus;
  }


  parameterSelect(id, event: MatCheckboxChange) {
    if (event.checked) {
      this.variableGroupParametersList.forEach(val => {
        if (val.Var_Id === id) {
          this.selectedParameter.push({ Var_Id: val.Var_Id, Var_Desc: val.Var_Desc });
        }
      });
      if (this.selectedParameter.length > 0) {
        this.getAlarmAnalysisDashboard();
      }
    } else {
      this.selectedParameter.pop(id);
      this.getAlarmAnalysisDashboard();
    }
  }

  getAlarmAnalysisDashboard() {
    var result = this.selectedParameter.map(function (val) {
      return val.Var_Id;
    }).join(',');
    this.spinner.show();
    const key = {
      startDate: this.rangeAlarm.value.dateStart,
      endDate: this.rangeAlarm.value.dateEnd,
      varId: result
    }
    this.productivityservice.getParameterAnalysisDashboard(key).subscribe(
      (data: any) => {
        this.alarmHoursData = data.Table4
        this.AlarmCycle();
        this.spinner.hide();
      },
      (error: any) => {
        this.toaster.error('Error', error.message);
        this.spinner.hide();
      }
    );
  }

  AlarmCycle():void {
    const yAxisArr: any[] = [];
    const xAxixArr: any[] = [];
    let array: any[] = [];
    const names = [];
    let diceEntries = new Set<string>();
    this.alarmHoursData.forEach(obj => {
      diceEntries.add(moment(obj.ResultOn).format('L'));
    })

    var data: any[] = [];
    data = this.alarmHoursData;

    for (let i = 0; i < this.selectedParameter.length; i++) {
      const dataArr = [];
      for (let j = 0; j < data.length; j++) {
        if (this.selectedParameter[i].Var_Id === data[j].Var_Id) {
          dataArr.push(parseFloat(data[j].Result));
        }
      }
      const obj = {
        name: this.selectedParameter[i].Var_Desc,
        data: dataArr
      };
      if (obj.data.length > 0) {
        array.push(obj);
      }
    }
    
    this.options = {
      chart: {
        type: 'column'
      },
      title: {
        text: ''
    },
    credits: {
      enabled: false
    },
      xAxis: {
       //tickInterval: 1000 * 60 * 60 * 24 * 365,
       type: 'datetime',
      //  min: 3600000,//this.getMili(this.AlarmDashboardForm.get('dateStart').value),
      //  max: 86400000,
       dateTimeLabelFormats: {
         day: "%H:%M"
       },
       //tickInterval: 1,
       labels: {
         overflow: 'justify',
         style: {
           color: '#46474a'
         }
       },
      },
   
      plotOptions: {
        series: {
          pointInterval: 3600000, // one hour
          pointStart:3600000 //this.getMili(this.AlarmDashboardForm.get('dateStart').value)
        },
        column: {
          stacking: 'normal'
        }
      },
   
      series: array
      
    };
    let chart = new Chart(this.options);
    this.alarmAnalysis = chart;
  }

}
